import React from 'react';

import image1 from "../../../Assets/Home/TrustedPartners/airbnb.png"
import image2 from "../../../Assets/Home/TrustedPartners/amazon.png"
import image3 from "../../../Assets/Home/TrustedPartners/walmart.png"
const TrustedPartners = () => {
  const logos = [
    { name: 'almart', src: image1 },
    { name: 'airbnb', src: image2 },
    { name: 'amazon', src: image3 },
    { name: 'google', src: image1 },
    { name: 'intel', src: image2 },
    { name: 'linkedin', src: image3 },
  ];

  return (
    <div className='bg-[#fafafa] md:px-10 px-6 md:py-10 py-4'>
      <style jsx>{`
        @keyframes marquee {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
        .animate-marquee {
          animation: marquee 30s linear infinite;
        }
      `}</style>
      <div data-aos="fade-up" data-aos-duration="700" className="relative overflow-hidden flex items-center  whitespace-nowrap">
        <span className=" text-primaryColor font-semibold text-lg z-10 bg-[#fafafa] py-6 whitespace-nowrap">
          Trusted Partner:
        </span>
        <div className="flex animate-marquee gap-10 items-center">
          {[...logos, ...logos].map((logo, index) => (
            <div key={index} className="flex-shrink-0  mx-4">
              <img
                src={logo.src}
                alt={logo.name}
                className="h-10 w-auto opacity-60 hover:opacity-100 transition-opacity"
              />
            </div>
          ))}
        </div>
        <div className='h-0.5 bg-black'></div>
      </div>
    </div>
  );
};

export default TrustedPartners;